import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, retry, throwError, timer } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PageMessagesService } from '@ideals/ui-components/page-messages';

import { AUTO_CLOSE_TIMEOUT } from '../../../types';

const RETRY_ENDPOINTS = [
  '/api/identity/password',
  '/api/identity/2fa',
  '/api/identity/email-code/verify',
  '/api/guest/email-code/verify',
  '/api/registration/validate2fa',
  '/api/2fa-reset/verify',
];

const TOO_MANY_REQUESTS_DELAY = 1000;

export function retryOn429Interceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const pageMessages = inject(PageMessagesService);

  const shouldRetry = RETRY_ENDPOINTS.some((endpoint) => request.url.includes(endpoint));

  if (!shouldRetry) {
    return next(request);
  }

  return next(request).pipe(
    retry({
      count: 1,
      delay: (error: HttpErrorResponse, retryCount: number) => {
        if ((error.status as HttpStatusCode) === HttpStatusCode.TooManyRequests) {
          return timer(TOO_MANY_REQUESTS_DELAY * retryCount);
        }

        return throwError(() => error);
      },
    }),
    catchError((error: HttpErrorResponse) => {
      if ((error.status as HttpStatusCode) === HttpStatusCode.TooManyRequests) {
        pageMessages.error({
          text: 'common.ERROR.your_request_cannot_be_processed',
          timeToClose: AUTO_CLOSE_TIMEOUT,
        });
      }

      return throwError(() => error);
    })
  );
}
